import { getPreferences } from "@/lib/preferences";

export const fmt = {
  usdt: (v) =>
    (Number(v) || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  dop: (v) =>
    (Number(v) || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  pct: (v) => `${(Number(v) || 0).toFixed(3)}%`,
  date: (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      const preferences = getPreferences();
      return d.toLocaleString(preferences.date_format === "MM/DD/YYYY" ? "en-US" : "es-DO", {
        dateStyle: "short",
        timeStyle: "short",
        timeZone: preferences.timezone,
        hour12: preferences.time_format === "12h",
      });
    } catch {
      return iso;
    }
  },
};

export const colorForPL = (v) =>
  Number(v) > 0 ? "text-emerald-600" : Number(v) < 0 ? "text-rose-600" : "text-slate-600";
